var __filename="/ui/index.js";var config = {
  filename: __filename
, styles: '../styles/ui'
, scripts: {
    connectionAlert: require('./connectionAlert'),
    //navLink: require('./navLink'),
    termsConditions: require('./termsConditions')
  }
};

module.exports = function(app, options) {
  app.createLibrary(config, options);
};
